import React from "react";
import EnterpriseDealer_image from "../../assets/image/png/EnterpriseDealer_image.png";

const EnterpriseDealerHero = () => {
  return (
    <div className="py-4 bg-white">
    <div className="pt-5 bg_darkskyblue">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h3 className=" fs_48 ff_raleway fw-bold text-white mb-0">
              Become a Drone Planet Enterprise Dealer
            </h3>
            <p className=" fs_16 ff_helvetica fw_400 text-white mt-4">
              Join the largest UAS network and expand your business offer with
              <br className="d-lg-block d-none"></br>
              valuable drone-based solutions.
            </p>
          </div>
          <div className="col-md-6">
            <img
              className="w-100"
              src={EnterpriseDealer_image}
              alt="EnterpriseDealer_image"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default EnterpriseDealerHero;
